import { CONTACT_TYPE_ID, CREDIT_MEMO_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import { CardAction, CardEmptyState, ChickletHoverActions, ChickletPrimaryDisplayLabel, ChickletSecondaryDisplayLabels, CardBottomContent, CardFooterAction } from './constants/BehaviorTypes';

// === CardEmptyState types ===

// === CardAction types ===

// === ChickletHoverActions types ===

export const isCreditMemoToContactChickletHoverActionsArguments = args => {
  return args.fromObjectTypeId === CREDIT_MEMO_TYPE_ID && args.toObjectTypeId === CONTACT_TYPE_ID;
};

// === ChickletPrimaryDisplayLabel types ===

// === ChickletSecondaryDisplayLabelTypes ===
// We use the GQL property definition
// === CardBottomContent types ===
// === CardFooterAction types ===
// === Core types ===